import { render, staticRenderFns } from "./AddEditCompany.vue?vue&type=template&id=55074d11&scoped=true"
import script from "./AddEditCompany.vue?vue&type=script&lang=js"
export * from "./AddEditCompany.vue?vue&type=script&lang=js"
import style0 from "./AddEditCompany.vue?vue&type=style&index=0&id=55074d11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55074d11",
  null
  
)

export default component.exports